// Admin LexiQamus Pages index — row click opens edit in a new tab (CPG-194 feedback).
import { Controller } from "stimulus"

export default class extends Controller {
  // Opens the site page edit URL in a new tab when a row is clicked.
  // Ignores clicks on action controls inside the row.
  rowClick(event) {
    const row     = event.currentTarget
    const editUrl = row.dataset.sitePageEditUrl
    if (!editUrl) return

    // Row click opens edit, but several child elements have their own behavior.
    // If the click started inside one of these, do not also run row navigation.
    const interactiveElements = event.target.closest(
      '.js-site-pages-index-actions, button'
    )

    // .js-site-pages-index-actions — Edit / Enable / Disable / Delete in the actions column
    // button — any other buttons in the row (e.g. Delete)
    if (interactiveElements) return

    // Open edit page in new tab (applies to both row clicks and Edit button actions)
    window.open(editUrl, '_blank', 'noopener,noreferrer')
  }
}
